module.exports = __webpack_public_path__ + "img/animazione-gonfiabili-operatore.6ab59689.jpg";